import React from "react";
import CultureDropdown from "./CultureDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

const CulturesTemplateDropdown = (props: DropdownWithoutOptionsProps<server.dto.LCID, server.dto.LCID>) => {
  const options = serverReference.templateCultures;
  const value = options.find(c => c.lcid === props.value);

  return <CultureDropdown
    excludeKeys={props.excludeKeys}
    value={value}
    onChange={(culture) => props.onChange(culture.lcid)}
    options={options}
    config={{
      isSearchable: true,
      ...props.config
    }}
  />;
};

export default CulturesTemplateDropdown;